import { createFeatureGuard } from './createFeatureGuard';
import { Feature } from './Constants';

export const externalTicketGuard = createFeatureGuard(Feature.ExternalTicket);